import React from 'react';
import { clsx } from 'clsx';

const sizes = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12',
};

export default function LoadingSpinner({ 
  size = 'md', 
  className = '', 
  color = 'primary',
  ...props 
}) {
  return (
    <div
      className={clsx(
        'loading-spinner',
        sizes[size],
        color === 'primary' && 'border-t-primary-600',
        color === 'white' && 'border-t-white border-gray-300',
        color === 'gray' && 'border-t-gray-600',
        className
      )}
      {...props}
    />
  );
}
